export const stock = [
  {
    id: "purpose",
    type: "dropdown",
    choices: ["Understand a company better"],
  },
  {
    id: "Company_Name",
    type: "input",
  },
];
